import { render, staticRenderFns } from "./management.cattle.io.globalrole.vue?vue&type=template&id=bddf8562&scoped=true&"
import script from "./management.cattle.io.globalrole.vue?vue&type=script&lang=js&"
export * from "./management.cattle.io.globalrole.vue?vue&type=script&lang=js&"
import style0 from "./management.cattle.io.globalrole.vue?vue&type=style&index=0&id=bddf8562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddf8562",
  null
  
)

export default component.exports